export class GrievanceNotificationDetailsRequest {
    public idGrievanceNotification: number;
    public idGrievanceNotificationStatus: number;
    public idUser: number;
    public idTriage: number;
    public idEpisode: number;
}